import React, { Component } from 'react'

class Header extends Component {

	render() {
		return (
			<section className="hero is-primary has-text-left">
				<div className="hero-body">
					<div className="container">
						<div className="columns">
							<div className="column">
								<h1 className="title">Repository Immagini</h1>
								<h2 className="subtitle">{this.props.subtitle}</h2>
							</div>
							<div style={{'alignItems': 'center'}} className="column is-narrow is-flex">
								<button onClick={this.props.logout} className="button is-danger">Logout</button>
							</div>
						</div>
					</div>
				</div>
			</section>
		)
	}
}

export default Header


// WEBPACK FOOTER //
// ./src/components/header.jsx